export default __webpack_public_path__ + "static/media/jesse.c6e17f5d.png";